export const updateCSSVar = (varName: string, value = ''): void => {
    if (!varName) {
        return;
    }

    document.body.style.setProperty(varName.startsWith('--') ? varName : `--${varName}`, value);
};
